import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";

@Component({
	selector: "obg-mitid-login-button-component",
	templateUrl: "./mitid-login-button.component.html",
	styleUrls: ["./mitid-login-button.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MitIdLoginButtonComponent {
	@HostBinding("class.obg-mitid-login-button") hostCssClass = true;
	@Output() click = new EventEmitter();
	@Input() busy = false;
	@Input() disabled = false;
	@Input() label: string | undefined;
	@Input() showMitIdIcon = false;
}
